"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "منصة Liaogao e Academy التدريبية عبر الإنترنت",
    "captchaNotEmpty": "يجب ملء رمز التحقق",
    "accountNotEmpty": "لا يمكن أن يكون الحساب فارغًا",
    "passwordBits": "لا يمكن أن يكون طول كلمة المرور أقل من 6 أرقام",
    "incorrectTips": "تم إدخال اسم المستخدم أو كلمة المرور بشكل غير صحيح",
    "sign": "تسجيل الدخول",
    "passwordNotEmpty": "كلمة السر لا يمكن أن تترك فارغة",
    "passwordBitsLong": "لا يمكن أن يكون طول كلمة المرور أكبر من 18 رقمًا",
    "captchaTips": "رمز التحقق غير صحيح",
    "confirmNot": "كلمة المرور المدخلة لا تتطابق مع كلمة المرور المؤكدة",
    "inputAccount": "الرجاء إدخال اسم المستخدم",
    "inputPassword": "الرجاء إدخال كلمة المرور",
    "inputCaptcha": "الرجاء إدخال رمز التحقق",
    "forgetPassword": "نسيت كلمة المرور",
    "nextStep": "الخطوة التالية",
    "inputUserName": "الرجاء إدخال اسم المستخدم",
    "phoneNumber": "رقم الهاتف",
    "phoneEmpty": "لا يمكن أن يكون رقم الهاتف فارغًا",
    "surePasswordEmpty": "تأكيد كلمة المرور لا يمكن أن يكون فارغًا",
    "userNameEmpty": "اسم المستخدم لا يمكن أن يكون فارغا",
    "getCaptcha": "احصل على رمز التحقق",
    "msgCaptcha": "رمز التحقق عبر الرسائل القصيرة",
    "prevStep": "السابق",
    "surePassword": "يرجى التأكد من صحة كلمة المرور الخاصة بك",
    "reset": "إعادة تعيين",
    "resetSuccess": "إعادة التعيين بنجاح",
    "resetSuccessTips": "لقد قمت بإعادة تعيين كلمة المرور الخاصة بك بنجاح ، يرجى الدخول إلى تسجيل الدخول",
    "loginNow": "قم بتسجيل دخولك الآن",
    "copyRight": "حقوق النشر مملوكة لشركة ××××××××× @ 2020 京 ICP 备案",
    "loginFail": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى!",
    "captchaFail": "فشل التحقق من رمز التحقق",
    "failTips": "فشل التحقق",
    "inputOrigPassword": "الرجاء إدخال كلمة المرور الأصلية",
    "inputNewPassowrd": "الرجاء إدخال كلمة مرور جديدة",
    "confimPassword": "يرجى التأكد من صحة كلمة المرور الخاصة بك",
    "sure": "تحديد",
    "cancel": "إلغاء",
    "changePasswordSuccess": "تم تحديث كلمة المرور",
    "continueLogin": "إعادة التسجيل",
    "resetLoginTips": "لقد نجحت في تغيير كلمة المرور الخاصة بك ، وتحتاج إلى تسجيل الدخول مرة أخرى ، وتسجيل الخروج تلقائيًا بعد 3 ثوانٍ",
    "passwordFormat": "يتراوح طول كلمة المرور من 8 إلى 32 رقمًا ، بما في ذلك الأرقام والأحرف الكبيرة والصغيرة",
    "changePassword": "تغيير كلمة السر",
    "poor": "ضعيف",
    "middle": "في",
    "strong": "قوي",
    "logout": "تسجيل الخروج بنجاح",
    "formerPhone": "رقم الهاتف الأصلي",
    "newPhone": "رقم هاتف جديد",
    "changePhoneSuccess": "تم تعديل رقم الهاتف المحمول بنجاح",
    "changePhoneSuccessTips": "لقد نجحت في تعديل رقم هاتفك",
    "goHome": "اذهب للمنزل",
    "changePhone": "تعديل رقم الهاتف المحمول",
    "newPhoneEmpty": "لا يمكن أن يكون رقم الهاتف الجديد فارغًا",
    "newPhoneFomat": "تنسيق رقم الهاتف الجديد غير صحيح",
    "newPhoneSupport": "لا يمكن أن يكون رقم الهاتف الجديد هو نفسه رقم الهاتف الأصلي",
    "newPhoneBinded": "تم تقييد رقم الهاتف الجديد",
    "orgPhoneEmpty": "لا يمكن أن يكون رقم الهاتف الأصلي فارغًا",
    "orgPhoneFormat": "تنسيق رقم الهاتف الأصلي غير صحيح",
    "orgPhoneNot": "رقم الهاتف الأصلي غير صحيح",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "phoneCaptchaEmpty": "لا يمكن أن يكون رمز التحقق من الهاتف فارغًا",
    "accountVerif": "تأكيد الحساب",
    "phoneVerif": "التحقق من الهاتف",
    "resetDone": "اكتمال إعادة التعيين",
    "phoneFormat": "تنسيق رقم الهاتف غير صحيح",
    "phoneBinded": "تم تقييد رقم الهاتف المحمول",
    "loginVertif": "مصادقة تسجيل الدخول",
    "clickGoHome": "انقر للعودة إلى صفحة تسجيل الدخول",
    "bingPhoneSuccess": "ربط رقم الهاتف المحمول بنجاح",
    "rightMessageChange": "يمكنك تحريره في المعلومات الشخصية على الجانب الأيمن من شريط التنقل",
    "bingPhone": "ربط رقم الهاتف المحمول"
  },
  "index": {
    "setAsHomePage": "الإعداد كصفحة أولى",
    "addCollection": "اضافة الى المفضلة",
    "telephone": "دعم الخط الساخن",
    "Help": "مركز المساعدة",
    "SystemMessage": "تذكير النظام",
    "message": "أخبار",
    "emptyMessage": "فارغة",
    "checkAllMessage": "مشاهدة الكل",
    "noMessage": "لايوجد بيانات",
    "fullScreen": "عرض ملء الشاشة",
    "ExitSystem": "اخرج من هذا النظام",
    "back": "إرجاع",
    "top": "أعلى",
    "backToTop": "عد إلى الأعلى",
    "homePage": "الصفحة الرئيسية",
    "course": "تعلم الدورة",
    "onlineCourse": "فئة خاصة عبر الإنترنت",
    "faceCourse": "التدريب وجهًا لوجه",
    "examPractice": "ممارسة الامتحان",
    "dataDownLoad": "تحميل",
    "userInfo": "المركز الشخصي",
    "Administration": "الخلفية الإدارية",
    "courseCategory": "أنواع الدورة",
    "examIsOver": "تم الانتهاء من التقييم",
    "onlineHours": "ساعات على الإنترنت",
    "faceHours": "ساعات الدراسة وجهًا لوجه",
    "notice": "إعلان",
    "checkAllNotice": "مشاهدة الكل",
    "backToTopButton": "عد إلى الأعلى",
    "recommendCourse": "الدورات الموصى بها",
    "impotentCourse": "بالطبع المفتاح",
    "newCourse": "أحدث الدورات",
    "hotCourse": "سخونة الدورة",
    "requiredCourses": "دورة اجبارية",
    "electiveCourses": "مقرر اختياري",
    "startStudy": "ابدأ في التعلم",
    "continueStudy": "أكمل دراستك",
    "coursesRanking": "ترتيب اختيار الدورة",
    "studentRanking": "تصنيفات الطلاب",
    "currentUser": "المستخدم الحالي",
    "userHead": "الصوره الشخصيه",
    "currentHead": "الصورة الرمزية الحالية",
    "change": "تعديل",
    "accountPassword": "كلمة مرور الحساب",
    "encryPhone": "هاتف سري",
    "currentPhone": "الهاتف الحالي",
    "userName": "اسم المستخدم",
    "head": "الصورة الرمزية",
    "coverImage": "صورة الغلاف",
    "uploadError": "التحميل فشل",
    "autoSetHomeTips": "متصفحك لا يدعم الإعداد التلقائي للصفحة الرئيسية ، يرجى استخدام قائمة المتصفح لتعيينها يدويًا!",
    "operateConfig": "تم رفض هذه العملية من قبل المستعرض. إذا كنت تريد تمكين هذه الوظيفة ، يرجى إدخال about: config في شريط العناوين ، ثم قم بتعيين قيمة موقع site.applets.codebase_principal_support إلى true",
    "favoriteTips": "نظرًا لمحدودية وظيفة متصفح 360 ، يرجى الضغط على Ctrl + D لوضع إشارة مرجعية يدويًا!",
    "autoFavorite": "متصفحك لا يدعمه ، يرجى الضغط على Ctrl + D لوضع إشارة مرجعية يدويًا!",
    "required": "هذا العنصر مطلوب",
    "to": "إلى",
    "trainingTime": "فترة التدريب",
    "coursehours": "ساعات الدراسة",
    "human": "اشخاص",
    "wecome": "أهلا بك!",
    "allCourses": "كل الدورات"
  },
  "course": {
    "coursesCategory": "أنواع الدورة",
    "allCourses": "كل الدورات",
    "electiveCourses": "الدورات الاختيارية",
    "requiredCourses": "الكورسات المطلوبة",
    "collect": "المفضلة",
    "cancelCollect": "غير مفضل",
    "searchTips": "الرجاء إدخال اسم الدورة",
    "startStudy": "ابدأ في التعلم",
    "continueStudy": "أكمل دراستك",
    "cancelConfirm": "غير مفضل",
    "cancelTips": "قم بالتأكيد لإلغاء المطالبة",
    "confirmButton": "زرالإلغاء",
    "count": "مجموع",
    "item": "مقالة - سلعة",
    "up": "الصفحة السابقة",
    "next": "الصفحة التالية",
    "items": "المقال / الصفحة",
    "go": "اقفز إلى",
    "page": "الصفحة",
    "man": "اشخاص",
    "score": "دقيقة",
    "courseYear": "عام",
    "courseTeachers": "مدرس",
    "noDesc": "لا مقدمة",
    "teachersDesc": "ملف تعريف المعلم",
    "checkLog": "عرض السجلات",
    "reExam": "إعادة الاختبار",
    "examLog": "سجل الامتحان",
    "viewPaper": "عرض ورقة الاختبار",
    "noPublicExam": "لن يتم الإعلان عن ورقة الاختبار",
    "marking": "العلامات",
    "closeButton": "اغلق",
    "examResultPage": "صفحة نتائج الامتحان",
    "examPage": "صفحة الاختبار",
    "startExam": "ابدأ الاختبار",
    "coursehours": "ساعات الدراسة",
    "courseInfo": "تفاصيل الدورة",
    "courseChapter": "فصول الدورة",
    "courseNote": "ملاحظات الدورة",
    "courseData": "دورة معلومات",
    "courseExamination": "امتحان",
    "evaluate": "تقييم",
    "courseEvaluate": "تقييم الدورة",
    "no": "أول",
    "chapter": "الفصل",
    "isEvaluate": "مقيمة",
    "uploadDate": "وقت التحميل",
    "className": "اسم الفصل",
    "resourceSize": "حجم المورد",
    "times": "مرات",
    "typeViedo": "فيديو",
    "typeImage": "صورة",
    "typeDoc": "توثيق",
    "typeOuth": "آخر",
    "typeImages": "صور متعددة",
    "newComment": "حتى الآن",
    "hotComment": "سخونة",
    "openComment": "اريد التعليق",
    "cancelButton": "إلغاء",
    "publishButton": "إطلاق سراح",
    "commentTips": "الرجاء إدخال محتوى التعليق",
    "emptyCommentTips": "لا يمكن أن يكون محتوى التعليق فارغًا",
    "noteSource": "من عند",
    "deleteNoteButton": "حذف",
    "needIETips": "تتطلب المناهج التعليمية الحالية متصفح IE!",
    "donwNum": "مرات التحميل",
    "preview": "معاينة",
    "relatedCourses": "الدورات ذات الصلة",
    "studentsNum": "عدد الدورات",
    "courseHours": "ساعات الدورة",
    "JoinLearning": "انضم إلى التعلم"
  },
  "onlineclass": {
    "allTheClass": "جميع الفئات",
    "beginClass": "بدأت الحصص",
    "notBeginClass": "لا فئة",
    "endClass": "مغلق",
    "searchThoseClass": "ابحث عن الفصل الخاص عبر الإنترنت الذي تهتم به",
    "startLearn": "أدخل الفصل",
    "registrationTime": "وقت التسجيل",
    "to": "إلى",
    "trainingTime": "فترة التدريب",
    "subjectsClass": "الدورات",
    "classStudy": "دراسة الفصل",
    "quantityOfCourses": "عدد الدورات",
    "numberOfParticipants": "عدد المتقدمون",
    "registerNow": "سجل الان",
    "resetRegister": "اسحب الاسم",
    "participating": "شارك",
    "subjects": "باب",
    "classExam": "امتحان الفصل",
    "notParticipat": "لا تشارك",
    "startExim": "ابدأ الاختبار",
    "handed": "تنفيذ مهمة",
    "score": "أحرز هدفا",
    "cacheSave": "التخزين المؤقت",
    "subjectsNumber": "عدد الأبواب",
    "notice": "تنويه",
    "communication": "الاتصالات",
    "detail": "تفاصيل",
    "courses": "دورة",
    "allClass": "الكل",
    "compulsory": "إلزامي",
    "elective": "اختياري",
    "Learned": "تعلمت",
    "classPassIndicator": "مؤشرات اجتياز الصف",
    "excellence": "ممتاز",
    "compulsoryNumber": "عدد التصاريح المطلوبة",
    "electiveNumber": "اجتاز عدد الاختيارية",
    "compulsoryStandard": "الساعات القياسية الإجبارية",
    "electiveStandard": "ساعات اختيارية",
    "examIsPass": "ما إذا كان الاختبار قد نجح",
    "resource": "مصادر",
    "source": "البيانات",
    "new": "حتى الآن",
    "hot": "سخونة",
    "updateTime": "وقت التحميل",
    "downloadCount": "التحميلات",
    "download": "تحميل",
    "resourceSize": "حجم المورد",
    "resourceType": "انواع من",
    "allType": "كل الانواع",
    "videos": "فيديو",
    "images": "صورة",
    "document": "توثيق",
    "others": "آخر",
    "multiImages": "صور متعددة",
    "inforCertificate": "شهادة",
    "notSubmit": "غير مقدم",
    "submitHomework": "تقديم الواجب المنزلي",
    "submitTime": "وقت التقديم",
    "uploadHomework": "تحميل المهمة",
    "clickHere": "انقر هنا",
    "upload": "رفع",
    "formatSupport": "دعم تنسيق الملف",
    "submited": "قدمت",
    "notApproved": "غير مراجع",
    "approved": "اجتاز الفحص",
    "downloadHomework": "تحميل المهمة",
    "reSubmit": "إعادة الإرسال",
    "myScore": "نتيجتي",
    "comments": "تعليقات",
    "talk": "مناقشة",
    "category": "تصنيف",
    "classTalk": "مناقشة في الصف",
    "groupTalk": "مناقشة جماعية",
    "wantTalk": "اريد ان اناقش",
    "publish": "إطلاق سراح",
    "undo": "إلغاء",
    "delete": "حذف",
    "iknow": "فهمت",
    "faceCourseClass": "التدريب وجهًا لوجه",
    "onlineClasses": "فئة خاصة عبر الإنترنت",
    "openReservation": "مفتوح للتسجيل",
    "talkTech": "محاضر",
    "address": "موقعك",
    "up": "على",
    "noon": "وقت الظهيرة",
    "down": "تحت",
    "even": "متأخر",
    "classOvered": "انتهى الفصل",
    "nopassed": "غير مسجل بعد",
    "inputTalkContent": "الرجاء إدخال محتوى المناقشة",
    "groupMan": "قائد مجموعة",
    "showAllGroup": "عرض جميع الأعضاء",
    "hideAllGroup": "أبعد كل أعضاء الفريق",
    "showAllMan": "عرض كل الطلاب",
    "hideAllMan": "ضع كل الطلاب بعيدًا",
    "reply": "الرد",
    "isDelete": "هل انت متأكد من الحذف؟",
    "cancelLike": "على عكس",
    "classNotStar": "التسجيل في الفصل لم يبدأ بعد",
    "classIsEnd": "انتهى تسجيل الفصل",
    "clickReset": "انقر فوق الزر لسحب الاسم",
    "agentRegister": "سجل مرة أخرى",
    "cancelRegister": "إلغاء التسجيل",
    "reason": "السبب",
    "inputReason": "الرجاء إدخال سبب الإلغاء",
    "homework": "عملية",
    "leaveMaxBits": "لا يمكن أن يتجاوز سبب طلب الإجازة 100 كلمة",
    "leaveNotEndTime": "لا يمكن أن يكون وقت بدء الإجازة مساويًا لوقت الانتهاء",
    "sizeNot": "لا يمكن أن يتجاوز الحجم",
    "close": "اغلق",
    "teacher": "مدرس",
    "noIntroduction": "لا مقدمة"
  },
  "offlineclass": {
    "fullTimeToFace": "تعليمات بدوام كامل وجهًا لوجه",
    "onlineToFace": "في العمل",
    "allClass": "جميع الفئات",
    "openClass": "صف مفتوح",
    "searchThoseClass": "ابحث عن الدورات التدريبية وجهًا لوجه التي تهتم بها",
    "startLearn": "أدخل التعلم",
    "classHours": "ساعات الدراسة",
    "h": "زمن",
    "firstWeek": "الأسبوع 1",
    "askLeave": "اريد ان اخذ اجازة",
    "monday": "يوم الاثنين",
    "tuesday": "الثلاثاء",
    "wednesday": "الأربعاء",
    "thursday": "الخميس",
    "fridays": "يوم الجمعة",
    "saturdays": "في. يوم السبت",
    "sunday": "بيوم الأحد",
    "morning": "صباح",
    "afternoon": "في الظهيرة",
    "evening": "بالمساء",
    "leaveType": "نوع من الإجازة",
    "selectLeaveType": "الرجاء تحديد نوع الإجازة",
    "leaveTime": "انتهى الوقت",
    "selctLeaveTime": "الرجاء تحديد وقت الإجازة",
    "reasonLeave": "السبب في إجازة",
    "inputReasonLeave": "الرجاء إدخال سبب الإجازة",
    "sure": "تحديد",
    "selectTime": "فترة الاختيار",
    "casualLeave": "إجازة شخصية",
    "sickLeave": "أجازة مرضية",
    "seven": "يوم",
    "one": "واحد",
    "two": "اثنان",
    "three": "ثلاثة",
    "for": "أربعة",
    "five": "الخمسات",
    "six": "ستة",
    "clear": "فارغة",
    "evaluating": "تقييم",
    "courseEvaluation": "تقييم التدريس",
    "inputEvaluating": "الرجاء إدخال محتوى التقييم",
    "beDoing": "في تقدم",
    "notStarted": "لم يبدأ",
    "evaluationInProgress": "التقييم قيد التقدم",
    "notEvaluation": "لم يتم تقييمه",
    "evaluationStartTime": "وقت بدء التقييم",
    "startEvaluation": "ابدأ التقييم",
    "classEvaluation": "تقييم الفصل",
    "photoCategory": "تصنيف الألبوم",
    "learningActivity": "هذا يحتاج الى مزيد من الاهتمام، يبدو جيدا",
    "addPhoto": "الصور المضافة الجديدة",
    "photoMessage": "معلومات الصورة",
    "photoName": "اسم الصورة",
    "inputPhotoName": "الرجاء إدخال اسم الصورة",
    "uploadPhoto": "رفع صورة",
    "formatSupport": "دعم تنسيق الدعم",
    "tickets": "تشانغ",
    "group": "مجموعة",
    "notGroup": "غير مصنف",
    "groupTalk": "مناقشة جماعية",
    "teacherAbout": "ملف تعريف المعلم",
    "teacherTech": "الدورات التي اتخذت",
    "photos": "إلبوم الصور",
    "phontoRequier": "يجب تحميل الصور",
    "addPhoneTips": "تمت الإضافة بنجاح ، يرجى الانتظار للمراجعة",
    "sureDelete": "هل أنت متأكد أنك تريد حذف",
    "deleteSuccess": "تم الحذف بنجاح",
    "phoneNameReq": "مطلوب حقل اسم الصورة",
    "longNotBits": "لا يمكن أن يتجاوز الطول 50 حرفًا",
    "phoneIsOccur": "اسم الصورة موجود بالفعل",
    "evaluateTime": "وقت التقييم",
    "evalueteNotStar": "التقييم لم يبدأ",
    "evaluateEnds": "انتهى التقييم",
    "isEvaluated": "تقييم",
    "at": "في",
    "submit": "إرسال",
    "seeEvalute": "مشاهدة التقييم",
    "inputIdea": "الرجاء إدخال أفكارك",
    "submitFailure": "فشل في التسليم",
    "seeRecord": "عرض السجلات",
    "examRecord": "سجل الامتحان",
    "seeSubmite": "عرض ورقة الاختبار",
    "resultPage": "صفحة نتائج الامتحان",
    "hoursStandard": "لا يمكن إجراء الاختبار إذا كانت ساعات الفصل لا ترقى إلى المستوى المطلوب",
    "examPage": "صفحة الاختبار",
    "questionnaire": "استبيان",
    " coursesTaught": "تدريس المقررات",
    "passed": "بواسطة",
    "is": "نعم",
    "not": "لا",
    "passedState": "حالة النجاح",
    "sketch": "مشروع",
    "partySchool": "فصل تدريب مدرسة الحزب",
    "searchPartySchool": "ابحث عن فصل تدريب مدرسة الحزب الذي تهتم به"
  },
  "exam": {
    "answerWarning": "سؤال هذا الامتحان هو سؤال واحد لا رجوع فيه ، يرجى توخي الحذر قبل السؤال التالي",
    "inputAnswerTips": "من فضلك أدخل إجابتك",
    "problemPoints": "تحليل المشكلة",
    "examination": "سجل للامتحان",
    "knowledgeCompetition": "مسابقة المعرفة",
    "practice": "ممارسة مستقلة",
    "notRegister": "غير مسجل",
    "reviewAudit": "قيد المراجعة",
    "auditNoPass": "فشل التدقيق",
    "participanted": "مسجل",
    "participant": "سجل",
    "examTime": "وقت الفحص",
    "examHours": "المدة الزمنية",
    "registration": "سجل بنجاح",
    "reRegistration": "اسحب الاسم",
    "wrongQuestion": "بنك سؤال خاطئ",
    "noInvolvement": "لا تشارك",
    "involvement": "شارك",
    "searchExamPractice": "ابحث عن الاختبارات والتمارين التي تهمك",
    "practiced": "تمارس",
    "startPractice": "ابدأ التمرين",
    "toFavorite": "اضافة الى المفضلة",
    "prevPrevious": "السؤال السابق",
    "nextPrevious": "السؤال التالي",
    "submitAnswers": "سلم الاجابة",
    "rightAnswers": "اجابة صحيحة",
    "yourAnswers": "اجابتك",
    "questionsAnalysis": "تحليل السؤال",
    "noAnalysis": "لا يوجد قرار",
    "accuracy": "المعدل الصحيح",
    "continuePracticed": "استمر بالتدريب",
    "topics": "موضوع"
  },
  "source": {
    "allResource": "كل الموارد",
    "commonResource": "الموارد العامة",
    "classResource": "موارد الفصل",
    "resourceCategory": "تصنيف الموارد",
    "searchResource": "ابحث عن الموارد التي تهتم بها",
    "resourceTalk": "تقييم الموارد",
    "previewResource": "معاينة الموارد",
    "helpPoint": "دليل المساعدة",
    "isEvaluation": "لقد قمت بالتقييم بالفعل!",
    "selectEvaluation": "لم تقم بتحديد تقييم!",
    "evaluationSuccess": "تقييم ناجح",
    "topRelise": "أعلى",
    "className": "اسم الفصل",
    "resourceEvaluation": "تصنيف الموارد"
  },
  "usercenter": {
    "386": "ملف التعلم",
    "myCourse": "دوراتي",
    "hours": "زمن",
    "loginAccount": "تسجيل الدخول",
    "htllo": "مرحبا",
    "welcomeMessage": "أتمنى لكم السعادة كل يوم",
    "underway": "انت تفعل",
    "annualAssessment": "التقييم السنوي",
    "searchTips": "أدخل اسم الدورة التي تم البحث عنها",
    "completed": "تم الانتهاء من",
    "allCourses": "كل الدورات",
    "requiredCourses": "الكورسات المطلوبة",
    "electiveCourses": "الدورات الاختيارية",
    "all": "الكل",
    "ongoing": "معالجة",
    "learnTo": "تعلم",
    "inExams": "خذ الاختبار",
    "noExams": "لا يوجد امتحان",
    "delete": "حذف",
    "pleaseSelect": "اختر من فضلك",
    "searchOnlineTips": "ابحث عن دروس خاصة عبر الإنترنت تهتم بها",
    "passedCourse": "تم الاجتياز بنجاح",
    "failedCourse": "لم ينجح",
    "myOnlineCourse": "صفي الخاص عبر الإنترنت",
    "myFaceCourse": "صفي التدريبي وجها لوجه",
    "searchFaceTips": "ابحث عن الدورات التي تهتم بها",
    "myExams": "امتحاني",
    "allExams": "كل الامتحانات",
    "makeUpExam": "لتكون مختلقة",
    "marking": "العلامات",
    "onExam": "امتحان في التقدم",
    "passedExam": "اجتاز الاختبار",
    "examHours": "مدة الاختبار",
    "examOver": "الامتحان قد انتهى",
    "exam": "الفحص",
    "examLog": "سجل الامتحان",
    "myScore": "نتيجتي",
    "surplusMakeUpExam": "امتحان المكياج المتبقي",
    "times": "مرات",
    "searchExamTips": "أدخل اسم البحث",
    "haveTime": "الوقت المتبقي",
    "question": "سؤال",
    "eachQuestion": "كل سؤال",
    "score": "دقيقة",
    "examExplain": "وصف الامتحان",
    "confirmHandExams": "سواء لتأكيد التقديم",
    "autoSaveFailed": "فشل الحفظ التلقائي",
    "autoSaveSuccess": "حفظ تلقائي",
    "handExamsSuccess": "سلمت بنجاح",
    "yourScore": "درجاتك",
    "noPublicAnswers": "لن يتم الإعلان عن الإجابات لهذا الاختبار",
    "noPublicResult": "لن يتم الإعلان عن ورقة الاختبار",
    "reExam": "إعادة الامتحان",
    "practice": "ممارسه الرياضه",
    "hasCollected": "جمعت",
    "emptyAnswer": "لا يمكن أن يكون محتوى الاختيار أو الإجابة فارغًا",
    "isCorrect": "حل إيجابي",
    "myCollected": "مجموعتي",
    "courseCollected": "مجموعة الدورات",
    "examCollected": "أسئلة الاختبار",
    "deleteCollected": "إزالة المفضلة",
    "myLeave": "إجازتي",
    "allLeave": "الجميع يغادر",
    "needAudit": "قيد الانتظار",
    "auditDate": "وقت التطبيق",
    "searchLeaveTips": "ابحث عن إجازة تهتم بها",
    "checkInfo": "انظر التفاصيل",
    "cancelLeave": "إبطال الإجازة",
    "leaveInfo": "اترك التفاصيل",
    "leaveState": "الوضع الحالي",
    "teamLeader": "قائد مجموعة",
    "committeeMembers": "لجنة فحص الانضباط المؤسسي",
    "headmaster": "مدير المدرسة",
    "schoolLeader": "قائد المدرسة",
    "student": "المتدرب",
    "auditMessage": "سبب الموافقة",
    "onBusiness": "من اجل العمل",
    "personal": "لتحقيق مكاسب شخصية",
    "rejectReasons": "سبب الرفض",
    "confirmCancel": "أكد ما إذا كنت تريد إلغاء الإجازة",
    "cancelButton": "سحب او إبطال",
    "cancelTitle": "تأكيد الإبطال",
    "empty": "لا",
    "wrongQuestionBank": "بنك الأسئلة الخاطئة",
    "searchWrongTips": "ابحث عن السؤال الخطأ الذي تهتم به",
    "deleteWrongQuestion": "إزالة بنك الأسئلة الخطأ",
    "myQuestionnaire": "استبياني",
    "isCompleted": "منجز",
    "isOver": "على",
    "searchQuestionnaireTips": "أدخل اسم استبيان البحث",
    "questionnaireDate": "وقت الاستبيان",
    "startQuestionnaire": "ابدأ في الرد",
    "checkQuestionnaire": "عرض الاستبيان",
    "allTeacher": "كل المعلمين",
    "newTeacher": "أضف المعلم",
    "searchTeacherTips": "ابحث عن المعلمين الذين تهتم بهم",
    "checkTeacher": "رأي",
    "editTeacher": "تعديل",
    "workingIn": "عملت في",
    "location": "موقع دائم",
    "confirmDelete": "تأكيد الحذف",
    "confirmDeleteTips": "تأكيد الحذف",
    "recommendTeacher": "توصية المعلم",
    "addTeachers": "مدرسين جدد",
    "teacherInfo": "معلومات شخصية",
    "teacherName": "اسم المعلم",
    "workUnit": "صاحب العمل",
    "contact": "بيانات المتصل",
    "teacherNameTips": "الرجاء إدخال اسم المعلم",
    "teacherWorkUnitTips": "الرجاء إدخال صاحب العمل",
    "teacherContactTips": "الرجاء إدخال معلومات الاتصال بالمدرس",
    "teacherLocationTips": "الرجاء إدخال الموقع الدائم",
    "teacherDescTips": "الرجاء إدخال ملف تعريف المعلم",
    "teachingInfo": "معلومات التدريس",
    "teachingExpertise": "الخبرة التدريسية",
    "fitLevel": "مناسبة لتدريس مستوى الكائن",
    "fitBusiness": "مناسب لخطوط الأعمال",
    "ruleNumber": "الرجاء إدخال عدد صحيح في حدود 8 أرقام (بما في ذلك 8)",
    "rulePhone": "يرجى إدخال رقم هاتف صالح",
    "ruleString": "الرجاء إدخال 80 حرفًا (بما في ذلك 80 حرفًا)",
    "ruleIsNumber": "الرجاء إدخال الرقم",
    "pause": "التخزين المؤقت",
    "teachingStyle": "أسلوب المحاضرة",
    "teachingExpertiseTips": "الرجاء إدخال خبرة المعلم في التدريس",
    "fitLevelTips": "الرجاء تحديد المستوى الذي يناسب الجمهور المستهدف",
    "fitBusinessTips": "الرجاء اختيار خط عمل مناسب",
    "chargeInfoTips": "الرجاء إدخال معيار الشحن",
    "teachingStyleTips": "الرجاء إدخال نمط محاضرة المعلم",
    "otherInfo": "معلومات أخرى",
    "recommendUnit": "أوصت به",
    "otherOption": "اشياء اخرى",
    "otherOptionTips": "الرجاء إدخال الأشياء الأخرى التي تحتاج إلى إضافتها",
    "isRequired": "هذا العنصر مطلوب",
    "pauseSuccess": "حفظ بنجاح",
    "phoneWrong": "يرجى إدخال رقم هاتف صالح",
    "junior": "طالب مدرسة ثانوية",
    "highSchool": "طالب المدرسة الثانوية",
    "english": "الإنجليزية",
    "mathematics": "الرياضيات",
    "recommendSuccessTips": "لقد نجحت في إرسال المدرس الموصى به. بعد اجتياز المراجعة ، ستتم إضافة المدرس إلى تجمع المدرسين",
    "goBackrecommend": "العودة إلى توصية المعلم",
    "checkTeacherInfo": "عرض المعلمين",
    "currentState": "الوضع الحالي",
    "chargeInfo": "شحنة",
    "myCertificate": "شهادتي",
    "learningArchives": "ملف التعلم",
    "allCertificate": "جميع الشهادات",
    "onlineCourse": "صف عبر الإنترنت",
    "faceCourse": "فئة وجها لوجه",
    "exams": "الفحص",
    "baseInfo": "معلومات اساسية",
    "userName": "اسم المستخدم",
    "name": "اسم",
    "company": "الوحدة الحالية",
    "learningExperience": "تاريخ الدراسة",
    "assessmentIndex": "مؤشر التقييم",
    "assessmentStatus": "حالة التقييم",
    "assessmentTime": "وقت الاختبار",
    "onlineLearning": "تعليم على الانترنت",
    "year": "عام",
    "faceOutProduceHours": "تعليمات وجهًا لوجه (ساعات الدراسة)",
    "notFaceOutProduceHours": "تعليمات وجهًا لوجه غير بدوام كامل (ساعات الدراسة)",
    "onlineCenterLearnHours": "التعلم المكثف عبر الإنترنت (ساعات الدراسة)",
    "onlineSelfLearnHours": "التعلم الذاتي عبر الإنترنت (ساعات الدراسة)",
    "outCompanyLearnHours": "الدراسة في الخارج (ساعات الدراسة)",
    "allHours": "الفترة الإجمالية",
    "onlineSelfLearn": "التعلم الذاتي عبر الإنترنت",
    "onlineCentralizedLearning": "التعلم المكثف عبر الإنترنت",
    "outCompanyLearn": "دراسة الوحدة الأجنبية",
    "faceTrain": "التدريب وجهًا لوجه",
    "myNotice": "رسالتي",
    "noticeSearchTips": "ابحث عن الأخبار التي تهتم بها",
    "systemNotice": "تذكير النظام",
    "message": "خطاب خاص"
  },
  "questionnaire": {
    "notParticipat": "لا تشارك",
    "description": "وصف الاستبيان",
    "save": "حفظ",
    "export": "تصدير",
    "printing": "طباعة",
    "handed": "تنفيذ مهمة",
    "topics": "موضوع",
    "examList": "قائمة أسئلة الاختبار",
    "tableQuestions": "سؤال الجدول",
    "newLine": "اضف سطر",
    "deleteLine": "احذف صف",
    "sort": "رقم سري",
    "content": "المحتوى",
    "shortQuestion": "اجابة قصيرة",
    "inputContent": "الرجاء إدخال محتوى الإجابة",
    "multiple": "متعدد الخيارات",
    "single": "متعدد الخيارات",
    "saveSuccess": "حفظ بنجاح",
    "submitSuccess": "تم الإرسال بنجاح",
    "submitTips": "لقد نجحت في إرسال الاستبيان ، شكرًا لك على مشاركتك",
    "closePage": "أغلق هذه الصفحة"
  },
  "play": {
    "endStudy": "نهاية الدراسة",
    "tips": "نصائح",
    "playTips": "تذكير: لضمان تسجيل وقت دراستك بشكل طبيعي بواسطة النظام ، يرجى النقر فوق الزر \"إنهاء الدراسة\" في الزاوية اليمنى العليا للخروج من الدراسة. إذا أغلقت المتصفح مباشرة ، فقد لا يتم تسجيل وقت دراستك بشكل طبيعي.",
    "notShowAgain": "لا تطالب بهذه الرسالة مرة أخرى",
    "gotIt": "فهمت",
    "chapter": "الفصل",
    "chapterText1": "أول",
    "chapterText2": "الفصل",
    "note": "ملاحظات",
    "noteBlockTitle": "ملاحظات",
    "evaluate": "تقييم",
    "evaluateStar": "نجمة",
    "saveEvaluate": "إرسال",
    "notePlaceholder": "الرجاء إدخال الملاحظات",
    "closeTips": "قد لا يقوم النظام بحفظ تغييراتك",
    "closeButton": "ابتعد أو ارحل",
    "autoStop": "توقف عن اللعب تلقائيًا",
    "autoStopTips": "نظرًا لأنك لم تعمل لفترة طويلة ، أوقف النظام تلقائيًا تشغيل الفيديو",
    "confirmOut": "هل أنت متأكد من التوقف عن اللعب؟",
    "closeOrNot": "ما إذا كان سيتم إغلاق النافذة الحالية",
    "noCoursePlay": "لا توجد مناهج تعليمية قابلة للعب في الدورة التدريبية الحالية",
    "attention": "يرجى الملاحظة!"
  }
};